import { render, staticRenderFns } from "./CardInRow.vue?vue&type=template&id=d88aee4a&scoped=true"
import script from "./CardInRow.vue?vue&type=script&lang=js"
export * from "./CardInRow.vue?vue&type=script&lang=js"
import style0 from "./CardInRow.vue?vue&type=style&index=0&id=d88aee4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88aee4a",
  null
  
)

export default component.exports